import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIconAddToCalendar, LazyIconArrowRight, LazyIconCalendar, LazyIconCardArrowRight, LazyIconCardLimit, LazyIconCarouselArrowLeft, LazyIconCarouselArrowRight, LazyIconChecklist, LazyIconCheckmark, LazyIconChevronDown, LazyIconChevronLeft, LazyIconChevronRight, LazyIconChevronUp, LazyIconCircleQuestionMark, LazyIconClose, LazyIconDeckSize, LazyIconExternalLink, LazyIconPlay, LazyIconInfo, LazyIconLightbulb, LazyIconLink, LazyIconLinkableArrowRight, LazyIconList, LazyIconLock, LazyIconMagnifyingGlass, LazyIconMenu, LazyIconMic, LazyIconMinus, LazyIconPause, LazyIconPencil, LazyIconPlayNegative, LazyIconPlayRounded, LazyIconPlus, LazyIconProfile, LazyIconProhibited, LazyIconRepeat, LazyIconRules, LazyIconShield, LazyIconThumbsDown, LazyIconThumbsUp, LazyIconTimes, LazyIconTrendingDown, LazyIconTrendingUp, LazyIconUsage, LazyIconVolume0, LazyIconVolume1, LazyIconVolume2, LazyIconVolumeX } from '#components'
const lazyGlobalComponents = [
  ["IconAddToCalendar", LazyIconAddToCalendar],
["IconArrowRight", LazyIconArrowRight],
["IconCalendar", LazyIconCalendar],
["IconCardArrowRight", LazyIconCardArrowRight],
["IconCardLimit", LazyIconCardLimit],
["IconCarouselArrowLeft", LazyIconCarouselArrowLeft],
["IconCarouselArrowRight", LazyIconCarouselArrowRight],
["IconChecklist", LazyIconChecklist],
["IconCheckmark", LazyIconCheckmark],
["IconChevronDown", LazyIconChevronDown],
["IconChevronLeft", LazyIconChevronLeft],
["IconChevronRight", LazyIconChevronRight],
["IconChevronUp", LazyIconChevronUp],
["IconCircleQuestionMark", LazyIconCircleQuestionMark],
["IconClose", LazyIconClose],
["IconDeckSize", LazyIconDeckSize],
["IconExternalLink", LazyIconExternalLink],
["IconPlay", LazyIconPlay],
["IconInfo", LazyIconInfo],
["IconLightbulb", LazyIconLightbulb],
["IconLink", LazyIconLink],
["IconLinkableArrowRight", LazyIconLinkableArrowRight],
["IconList", LazyIconList],
["IconLock", LazyIconLock],
["IconMagnifyingGlass", LazyIconMagnifyingGlass],
["IconMenu", LazyIconMenu],
["IconMic", LazyIconMic],
["IconMinus", LazyIconMinus],
["IconPause", LazyIconPause],
["IconPencil", LazyIconPencil],
["IconPlayNegative", LazyIconPlayNegative],
["IconPlayRounded", LazyIconPlayRounded],
["IconPlus", LazyIconPlus],
["IconProfile", LazyIconProfile],
["IconProhibited", LazyIconProhibited],
["IconRepeat", LazyIconRepeat],
["IconRules", LazyIconRules],
["IconShield", LazyIconShield],
["IconThumbsDown", LazyIconThumbsDown],
["IconThumbsUp", LazyIconThumbsUp],
["IconTimes", LazyIconTimes],
["IconTrendingDown", LazyIconTrendingDown],
["IconTrendingUp", LazyIconTrendingUp],
["IconUsage", LazyIconUsage],
["IconVolume0", LazyIconVolume0],
["IconVolume1", LazyIconVolume1],
["IconVolume2", LazyIconVolume2],
["IconVolumeX", LazyIconVolumeX],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
